/**
 * VisitTracker — v3.2.44
 *
 * Thin wrapper that calls the useVisitTracker hook. Kept as a component
 * so App.js can drop it inside the <BrowserRouter> without becoming a
 * function component itself. Renders nothing.
 */
import useVisitTracker from "@/hooks/useVisitTracker";

export default function VisitTracker() {
  useVisitTracker();
  return null;
}
